import { render, staticRenderFns } from "./ModalCustomSize.vue?vue&type=template&id=f6428c8e"
import script from "./ModalCustomSize.vue?vue&type=script&lang=js"
export * from "./ModalCustomSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports